module.exports = __webpack_public_path__ + "static/media/button-sumbit.d5fafc7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/value-investment/button-sumbit.png
// module id = 793
// module chunks = 0